/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import autobind from "autobind-decorator";
import {EnvironmentalBenefitFieldEditor} from "../ServiceDrivenEditors";
``
export class ProgramEnvironmentalBenefitFieldEditor extends EnvironmentalBenefitFieldEditor {
	@autobind
	filterResults(values, selectedModel) {
		const {Value, RootData} = this.props;
		values = super.filterResults(values, selectedModel) ?? values;

		//strip already selected EnvironmentalBenefits
		let selectedIds = [];
		if (RootData.ProgramEnvironmentalBenefits) {
			selectedIds = RootData.ProgramEnvironmentalBenefits
				.map(x => x.environmentalBenefitId)
				.filter(x => !isNaN(x))
				.filter(x => x !== Value);
		}

		return values.filter(x => !selectedIds.includes(x.environmentalBenefitId));
	}
}